import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MisingSubtitlesNotification.module.scss';
import { MISSING_MODE } from '../../const';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';

const { TRANSCRIPTION } = MISSING_MODE;

const MisingSubtitlesNotification = ({ mode, visible, onGenerate, onDisable }) => {
  const [isTranscription, setIsTranscription] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsTranscription(mode === TRANSCRIPTION);
  }, [mode]);

  return visible ? (
    <div className={styles.isMissingContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.attentionGrabberContainer}>
          <Icon src="exclamationMark" className={styles.exclamationMark} />
          <h3 className={styles.header}>
            {isTranscription ? t('subtitles.editor.missing.transcription') : t('subtitles.editor.missing.translation')}
          </h3>
        </div>
      </div>

      <p className={styles.text}>
        {isTranscription ? t('subtitles.editor.missing.transcriptions_text') : t('subtitles.editor.missing.translation_text')}
      </p>
      <div className={styles.generateContaner}>
        <CustomButton
          variant="primary"
          className={styles.generateButton}
          onClick={onGenerate}
          label={isTranscription ? t('subtitles.editor.generate') : t('subtitles.editor.generate_translation')}
        />
      </div>
    </div>
  ) : null;
};

export default MisingSubtitlesNotification;
